/* eslint-disable react/no-array-index-key */
import React, { useRef } from 'react';
import { css } from '@emotion/core';
import DtvtCard from './DtvtCard';

const DtvtTable = css`
  flex: 1;
  width: 180px;
  position: relative;
`;

const DtvtTableContent = css`
  position: absolute;
  top: 0;
  left: 0;
  width: '100%';
  height: '100%';
`;

const DtvtColumn = ({ dtvts }) => {
  const dtvtContainerRef = useRef(null);

  return (
    <div css={DtvtTable} ref={dtvtContainerRef}>
      <div css={DtvtTableContent}>
        {dtvts.reduce((result, dtvt, i) => {
          if (!dtvt) return result;
          try {
            const { dealTransactionRef, voucherTransactionRef } = dtvt;
            const dtRefBox = dealTransactionRef.current.getBoundingClientRect();
            const itRefBox = voucherTransactionRef.current.getBoundingClientRect();
            const containerRefBox = dtvtContainerRef.current.getBoundingClientRect();
            result.push(
              <DtvtCard
                dtRefBox={dtRefBox}
                itRefBox={itRefBox}
                containerRefBox={containerRefBox}
                dtvt={dtvt}
                key={i}
              />,
            );
          } catch (e) {
            console.error(e);
          }
          return result;
        }, [])}
      </div>
    </div>
  );
};

export default DtvtColumn;
